import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { LabelKey } from '@shared/models';
import { UrlParamsService } from '@shared/services/url-params';

@Component({
  selector: 'app-filter-toggle-group',
  imports: [],
  templateUrl: './filter-toggle-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterToggleGroupComponent implements OnInit {
  filters = input.required<LabelKey[]>();
  filterName = input.required<string>();
  allowMultiple = input<boolean>(false);
  filtersSelected = signal<Set<string>>(new Set());
  private readonly urlParamsService = inject(UrlParamsService);

  ngOnInit(): void {
    const existingFilters = this.urlParamsService.param(this.filterName())();
    const filters = this.filters();
    if (this.allowMultiple() && existingFilters) {
      const existingFiltersSplit = existingFilters.split('__');
      this.filtersSelected.set(new Set(existingFiltersSplit));
    } else if (!this.allowMultiple()) {
      if (existingFilters) {
        this.filtersSelected.set(new Set([existingFilters]));
      } else {
        const firstFilter = filters[0]!;
        this.filtersSelected.set(new Set([firstFilter.key]));
        this.updateUrlParams();
      }
    }
  }

  onToggle(key: string): void {
    if (this.allowMultiple()) {
      this.filtersSelected.update((currentFilters) => {
        const newFilters = new Set(currentFilters);
        if (newFilters.has(key)) {
          newFilters.delete(key);
        } else {
          newFilters.add(key);
        }
        return newFilters;
      });
      this.updateUrlParams();
    } else if (!this.filtersSelected().has(key)) {
      this.filtersSelected.set(new Set([key]));
      this.updateUrlParams();
    }
  }

  private updateUrlParams(): void {
    const filterName = this.filterName();
    const filtersSelected = [...this.filtersSelected()].sort((a, b) => a.localeCompare(b));
    const filtersSelectedJoin = filtersSelected.join('__');

    if (filtersSelectedJoin.length === 0) {
      this.urlParamsService.removeParams(filterName);
    } else {
      this.urlParamsService.mergeParams({ [filterName]: filtersSelectedJoin });
    }
  }
}
